<div adaptToolbarContent
     adaptBlockingButtonGroup>
    <button adaptButton="save"
            [adaptBlockingClick]="save"
            [disabled]="!editFeaturesComponent"></button>
    <button adaptButton="cancel"
            [adaptBlockingClick]="cancel"
            [disabled]="!editFeaturesComponent"></button>
</div>

<adapt-select-organisation (organisationChange)="selectedOrganisation = $event"></adapt-select-organisation>
@if (selectedOrganisation) {
    <adapt-edit-organisation-features [organisation]="selectedOrganisation"></adapt-edit-organisation-features>
}
